import downloadAppImage from '@/assets/download-app.svg';
import {BrandLogoCircle} from '@/components/brand/BrandLogoCircle';
import {useBrand} from '@/contexts/BrandContext';
import {useIsMobile, ReferencingLayout} from '@ark/web';
import {useLogEvent} from '@/hooks/useLogEvent/useLogEvent';
import {StepContent} from '@/components/display/StepContent';
import {Box, Typography} from '@mui/material';
import {CortileDownloadApp} from '@/pages/ENT/CortileLogin/CortileDownloadApp';
import {useEffect, useState} from 'react';

export type AppStoreText = 'Play Store' | 'App Store' | undefined;

const playStoreUrl =
  'https://play.google.com/store/apps/details?id=com.projectark.app&hl=en_GB&gl=US';
const appStoreUrl = 'https://apps.apple.com/gb/app/ark-residents/id1514785878';

const ArkAppStoreRedirect = () => {
  const [showCloseText, setShowCloseText] = useState(false);
  const userAgent = navigator.userAgent;
  const logEvent = useLogEvent();
  const isMobile = useIsMobile();
  const {assets, resolved} = useBrand();

  let redirectUrl: string | undefined = undefined;
  let appStoreText: AppStoreText = undefined;

  if (/android/i.test(userAgent)) {
    appStoreText = 'Play Store';
    redirectUrl = playStoreUrl;
  } else if (/iPad|iPhone|iPod/i.test(userAgent)) {
    appStoreText = 'App Store';
    redirectUrl = appStoreUrl;
  }

  const redirect = window.open('', '_self');

  useEffect(() => {
    if (redirectUrl && redirect) {
      redirect.location.href = redirectUrl;
      setShowCloseText(true);
      logEvent({
        name: 'App Store Redirect',
        data: {
          store: appStoreText,
        },
      });
    }
  }, [redirectUrl, redirect, logEvent, appStoreText]);

  let content = null;
  if (!isMobile) {
    content = (
      <Typography variant="h4" textAlign="center" sx={{marginTop: 3}}>
        Please open this link on your mobile device.
      </Typography>
    );
  } else if (showCloseText) {
    content = (
      <Typography variant="h4" textAlign="center" sx={{marginTop: 3}}>
        You can close this window.
      </Typography>
    );
  } else {
    content = (
      <Typography variant="h4" textAlign="center" sx={{marginTop: 3}}>
        You are being redirected to the {appStoreText}.
      </Typography>
    );
  }

  if (!resolved) return null;

  return (
    <ReferencingLayout background={assets.tiledBackground}>
      <Box
        display="flex"
        justifyContent="center"
        sx={{
          marginTop: 2,
        }}
      >
        <BrandLogoCircle />
      </Box>
      <StepContent sx={{mx: 0, mb: 0}} overflow="hidden">
        {content}
        <img src={downloadAppImage} alt="download app" />
      </StepContent>
    </ReferencingLayout>
  );
};

export const AppStoreRedirect = () => {
  const {key, confirmed} = useBrand();
  if (!confirmed) return null;
  return (
    <>
      {key === 'cortile' && <CortileDownloadApp />}
      {key !== 'cortile' && <ArkAppStoreRedirect />}
    </>
  );
};
